module.exports = __webpack_public_path__ + "static/media/ramen_soysauce.0cd268bd.jpg";